const SESSION_ID_KEY = 'user_session_id'

const getSessionId = () => {
  const id = sessionStorage.getItem(SESSION_ID_KEY)

  if (id) return id

  const newId = window.crypto.randomUUID()
  sessionStorage.setItem(SESSION_ID_KEY, newId)

  return newId
}

const getRequestId = () => {
  return window.crypto.randomUUID()
}

export const getLoggingHttpHeaders = ({
  version,
  gameCode,
}: {
  version: string
  gameCode?: string
}) => {
  const headers = {
    'X-Request-ID': getRequestId(),
    'X-Client-Version': version,
    'X-Session-ID': getSessionId(),
    ...(gameCode ? {'X-Game-Code': gameCode} : null),
  }

  return Object.entries(headers).map(([key, value]) => ({key, value}))
}

export const getWsLoggingParams = ({version}: {version: string}) => {
  const searchParams = new URLSearchParams()

  searchParams.set('sessionId', getSessionId())
  searchParams.set('requestId', getRequestId())
  searchParams.set('clientVersion', version)

  return searchParams
}
